export const Footer = () => (
  <footer className="bg-ink border-t border-cream/10 py-12" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
      <div>
        <p className="font-display text-gold text-2xl">R·C·K</p>
        <p className="text-cream/50 text-xs mt-2">© {new Date().getFullYear()} Rachelle Cooper Kulkarni. Shaping a brighter future.</p>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-3">
        <a href="https://www.sustainify.com.au/" target="_blank" rel="noopener noreferrer" data-testid="footer-link-sustainify" className="eyebrow text-cream/60 hover:text-gold transition-colors">Sustainify</a>
        <a href="https://www.linkedin.com/in/rachellecooperkulkarni/" target="_blank" rel="noopener noreferrer" data-testid="footer-link-linkedin" className="eyebrow text-cream/60 hover:text-gold transition-colors">LinkedIn</a>
        <a href="http://www.liminalwomyn.com" target="_blank" rel="noopener noreferrer" data-testid="footer-link-podcast" className="eyebrow text-cream/60 hover:text-gold transition-colors">The Liminal Womyn Podcast</a>
        <a href="mailto:rachelle@sustainify.com.au" data-testid="footer-link-email" className="eyebrow text-cream/60 hover:text-gold transition-colors">Email</a>
      </div>
    </div>
  </footer>
);
